import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, MessagePlugin, Textarea, Upload, Select } from 'tdesign-react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Tip from '@/components/Tip';
import { uploadPackage } from '@/services/functionService';
import { isVoid } from '@/utils/common';
import TNItems from '../../../components/TNItems';

const { FormItem } = Form;

export default function ModalForm({ visible, handleClose, packageOptions, options, row }) {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);

  const namespace = Form.useWatch('namespace', form);
  const packageName = Form.useWatch('packageName', form);
  const packageType = Form.useWatch('packageType', form);
  const functionRuntime = Form.useWatch('functionRuntime', form);
  const clusterName = searchParams.get('name');

  const isEdit = !isVoid(row);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        const formData = new FormData();
        if (isEdit) {
          formData.append('packageFile', fields.packageFile[0].raw);
          formData.append('clusterName', clusterName);
          formData.append('functionRuntime', row.functionRuntime);
          formData.append('packageType', row.packageType);
          formData.append('version', fields.version);
          formData.append('packageName', row.packageName);
          formData.append('description', fields.description);
          if (row.functionRuntime === 'Python') {
            formData.append('fileName', fields.fileName);
          }
        } else {
          const name = `${packageType.toLowerCase()}://${fields.namespace}/${fields.packageName}`;
          formData.append('packageFile', fields.packageFile[0].raw);
          formData.append('clusterName', clusterName);
          formData.append('functionRuntime', fields.functionRuntime);
          formData.append('packageType', packageType);
          formData.append('version', fields.version);
          formData.append('packageName', name);
          formData.append('description', fields.description);
          if (functionRuntime === 'Python') {
            formData.append('fileName', fields.fileName);
          }
        }
        await uploadPackage(formData);
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (!visible) {
      form.reset();
    }
  }, [visible, form]);

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({ packageName: row.packageName });
    }
  }, [isEdit, row, form, visible]);

  return (
    <Dialog
      header={isEdit ? '新增版本' : '包上传'}
      onConfirm={() => form.submit()}
      confirmBtn={{ loading: submitting, content: '确定' }}
      visible={visible}
      width={600}
      onClose={() => {
        if (submitting) {
          MessagePlugin.warning('正在上传，请稍后关闭');
          return;
        }
        handleClose();
      }}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '90%' }} labelWidth={140}>
        {!isEdit && (
          <>
            <TNItems clusterName={clusterName} isEdit />
            <FormItem label='包类型' name='packageType' rules={[{ required: true }]}>
              <Select options={packageOptions} clearable />
            </FormItem>
            <FormItem label='任务类型' name='functionRuntime' rules={[{ required: true }]}>
              <Select options={options} clearable />
            </FormItem>
          </>
        )}
        <FormItem name='packageName' label='包名称' rules={[{ required: true }]}>
          <Input disabled={isEdit} />
        </FormItem>
        {packageType && packageName && namespace && (
          <TipContainer>
            {packageType.toLowerCase()}
            {'://'}
            {namespace}/{packageName}
          </TipContainer>
        )}
        <FormItem name='packageFile' label='包文件' rules={[{ required: true }]}>
          <Upload theme='file' autoUpload={false} />
        </FormItem>
        <FormItem
          name='version'
          label='版本'
          rules={[{ required: true }, { pattern: /^[0-9.]+$/, message: '只能包含数字和.' }]}
        >
          <Input />
        </FormItem>
        {functionRuntime === 'Python' && (
          <FormItem
            name='fileName'
            label={
              <Tip content={'Python任务需要指定实际执行的文件名(如test.py)，才能启动'}>
                Python文件名
              </Tip>
            }
            rules={[{ required: true, message: '请输入Python文件名' }]}
          >
            <Input />
          </FormItem>
        )}
        <FormItem name='description' label='说明' rules={[{ required: true }]}>
          <Textarea />
        </FormItem>
      </Form>
    </Dialog>
  );
}

const TipContainer = styled.div`
  margin-bottom: 12px;
  margin-left: 140px;
  margin-top: -12px;
  font-size: 12px;
  color: var(--td-text-color-secondary);
`;
